// DS: CR28M
import React, { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import NotificationIcon from '@wix/da-ds/pkg/Icons/24x24/Notification';
import { NCContext } from '@wix/da-react-context/pkg/NCContext';
import SiteHeaderIconButton from '../_partials/SiteHeaderIconButton';
var NotificationsDropdownWrapperMobile = function (_a) {
    var feedbackCount = _a.feedbackCount, toggleFeedbackPage = _a.toggleFeedbackPage, biData = _a.biData, isLegacyHeader = _a.isLegacyHeader, className = _a.className;
    var t = useTranslation().t;
    var isStandalonePage = useContext(NCContext).isStandalonePage;
    var handleIconClick = useCallback(function () {
        if (isLegacyHeader) {
            window.location.assign(Url.feedbackLink());
            return;
        }
        if (!isStandalonePage) {
            toggleFeedbackPage();
        }
    }, [isStandalonePage, isLegacyHeader, toggleFeedbackPage]);
    return (React.createElement("div", { className: className },
        React.createElement(SiteHeaderIconButton, { icon: NotificationIcon, biData: biData, onClick: handleIconClick, ariaLabel: t('siteHeader.a11y.notifications'), count: feedbackCount })));
};
NotificationsDropdownWrapperMobile.displayName =
    'NotificationsDropdownWrapperMobile';
export default NotificationsDropdownWrapperMobile;
//# sourceMappingURL=NotificationsDropdownWrapperMobile.js.map